import { PlusOutlined, UpOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  Button,
  type FormProps,
  Flex,
  theme,
  Dropdown,
  MenuProps,
  Select,
  message,
} from "antd";
import { useForm } from "antd/es/form/Form";
import { API_URL_CONTACT_GROUPS } from "@/services/XCONS_ENV";
import { axiosInstance } from "@/utilities";
import { useContext, useState } from "react";
import { SmartMenuContext } from "@/config/context/smartMenuContext";
import { useSelectedStores } from "@/config/context/SelectedItemsContext";

const sellersMock = [
  {
    sellerCode: "puntoseco",
    label: "Puntoseco",
  },
];

type Seller = {
  sellerCode: string;
  label: string;
};

type GroupsCreateProps = {
  formProps: FormProps;
  t: (key: string) => string;
  storesSelectProps?: any;
  refetch?: any;
};

export const GroupsCreate: React.FC<GroupsCreateProps> = ({
  formProps,
  t,
  storesSelectProps,
  refetch,
}) => {
  const { token } = theme.useToken();
  const [form] = useForm();
  const [createLoading, setCreateLoading] = useState(false);
  const { selectedStores } = useSelectedStores();
  const [storeCode, setStoreCode] = useState<string>(selectedStores[0]?.code);

  const onSubmit = async (values: any) => {
    setCreateLoading(true);
    const requestData = {
      name: values.name,
      storeCode,
    };

    try {
      await axiosInstance.post(API_URL_CONTACT_GROUPS, requestData);
      console.log("Group created successfully", requestData);
      refetch();
    } catch (error: any) {
      console.error("Error creating group", requestData);
      if (error.response?.data?.message === "Insufficient permissions") {
        message.error(t("insufficient.permissions"));
      } else {
        message.error("Error al crear el grupo");
      }
    } finally {
      setCreateLoading(false);
    }
  };

  return (
    <Form layout="vertical" {...formProps} form={form} onFinish={onSubmit} style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
      <div style={{ flex: 1, overflowY: "auto", padding: "16px 24px" }}>
      <Form.Item
        label={
          <span style={{ color: token.colorTextTertiary }}>Group name</span>
        }
        name="name"
        rules={[
          {
            required: true,
            whitespace: true,
            message: t("message.error.inputEmpty"),
          },
        ]}
      >
        <Input type="text" />
      </Form.Item>

      <div style={{ color: token.colorTextSecondary, marginBottom: 24 }}>
        {t("contacts.groups.create.description")}
      </div>

      <Form.Item
        label={
          <span style={{ color: token.colorTextTertiary }}>
            Link to a store
          </span>
        }
        name="sellerCode"
        initialValue={selectedStores[0]?.code}
        rules={[
          {
            required: true,
            message: "Por favor selecciona un store",
          },
        ]}
      >
        <Flex vertical>
          <Select
            disabled={createLoading}
            allowClear
            options={storesSelectProps?.map((option: any) => ({
              label: option?.name as string,
              value: option?.code as string,
            }))}
            defaultValue={selectedStores[0]?.code}
            onChange={(value) => {
              setStoreCode(value);
              form.setFields([{ name: "sellerCode", value, errors: [] }]);
            }}
          />
        </Flex>
      </Form.Item>

      </div>
      <Flex
        align="center"
        justify="end"
        gap="8px"
        style={{ flexShrink: 0, padding: "12px 24px", borderTop: "1px solid #f0f0f0", backgroundColor: "#fff" }}
      >
        <Button type="default" danger>
          {t("buttons.cancel")}
        </Button>

        <Button
          loading={createLoading}
          type="primary"
          htmlType="submit"
          iconPosition="end"
          icon={<PlusOutlined />}
        >
          {t("button.createnewgroup")}
        </Button>
      </Flex>
    </Form>
  );
};
